const FooterMenus = document.querySelectorAll(".footer__menu");
const FooterMenuHeadings = document.querySelectorAll(".footer__menu-heading");

//add matching class to each footer menu wrapper
FooterMenus.forEach((menu) => {
  menu.parentElement.classList.add("footer__accordion");
});

//Add a click event to each footer menu header
FooterMenuHeadings.forEach((heading) => {
  heading.addEventListener("click", (e) => {
    accordionControls(heading);
  });
});

///function - add/remove classes that control the sub menu
const accordionControls = (heading) => {
  const parent = heading.parentElement;
  const accordion = parent.querySelector(".footer__accordion");
  if (accordion.classList.contains("open")) {
    accordion.classList.remove("open");
    heading.classList.remove("active");
  } else {

    //close all other accoodions 
    FooterMenuHeadings.forEach((heading) => {
      const parent = heading.parentElement;
      const accordion = parent.querySelector(".footer__accordion");
      accordion.classList.remove("open");
      heading.classList.remove("active");
    });
    
    accordion.classList.add("open");
    heading.classList.add("active");
  }
};
